/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentRegimenInvestigations } from 'app/entities/treatment-regimen-investigation/treatment-regimen-investigation.reducer';
import { getEntities as getRadiologyStudies } from 'app/entities/radiology-study/radiology-study.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getUserPanelItems } from 'app/entities/user-panel-item/user-panel-item.reducer';
import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-regimen-investigation-obs.reducer';

export const TreatmentRegimenInvestigationObsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentRegimenInvestigations = useAppSelector(state => state.treatmentRegimenInvestigation.entities);
  const radiologyStudies = useAppSelector(state => state.radiologyStudy.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const userPanelItems = useAppSelector(state => state.userPanelItem.entities);
  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const treatmentRegimenInvestigationObsEntity = useAppSelector(state => state.treatmentRegimenInvestigationObs.entity);
  const loading = useAppSelector(state => state.treatmentRegimenInvestigationObs.loading);
  const updating = useAppSelector(state => state.treatmentRegimenInvestigationObs.updating);
  const updateSuccess = useAppSelector(state => state.treatmentRegimenInvestigationObs.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-regimen-investigation-obs${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentRegimenInvestigations({}));
    dispatch(getRadiologyStudies({}));
    dispatch(getDiagLabPanels({}));
    dispatch(getUserPanelItems({}));
    dispatch(getUserLabTestItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentRegimenInvestigationObsEntity,
      ...values,
      regimenInvestigation: treatmentRegimenInvestigations.find(it => it.id.toString() === values.regimenInvestigation?.toString()),
      imageStudy: radiologyStudies.find(it => it.id.toString() === values.imageStudy?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      panelItem: userPanelItems.find(it => it.id.toString() === values.panelItem?.toString()),
      labTestItemResult: userLabTestItems.find(it => it.id.toString() === values.labTestItemResult?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentRegimenInvestigationObsEntity,
          regimenInvestigation: treatmentRegimenInvestigationObsEntity?.regimenInvestigation?.id,
          imageStudy: treatmentRegimenInvestigationObsEntity?.imageStudy?.id,
          panel: treatmentRegimenInvestigationObsEntity?.panel?.id,
          panelItem: treatmentRegimenInvestigationObsEntity?.panelItem?.id,
          labTestItemResult: treatmentRegimenInvestigationObsEntity?.labTestItemResult?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.treatmentRegimenInvestigationObs.home.createOrEditLabel"
            data-cy="TreatmentRegimenInvestigationObsCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.home.createOrEditLabel">
              Create or edit a TreatmentRegimenInvestigationObs
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-regimen-investigation-obs-id"
                  label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.active')}
                id="treatment-regimen-investigation-obs-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.cursor')}
                id="treatment-regimen-investigation-obs-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.lastUpdated')}
                id="treatment-regimen-investigation-obs-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.microSec')}
                id="treatment-regimen-investigation-obs-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.timestampEntry')}
                id="treatment-regimen-investigation-obs-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-regimen-investigation-obs-regimenInvestigation"
                name="regimenInvestigation"
                data-cy="regimenInvestigation"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.regimenInvestigation')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRegimenInvestigations
                  ? treatmentRegimenInvestigations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-obs-imageStudy"
                name="imageStudy"
                data-cy="imageStudy"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.imageStudy')}
                type="select"
              >
                <option value="" key="0" />
                {radiologyStudies
                  ? radiologyStudies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-obs-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-obs-panelItem"
                name="panelItem"
                data-cy="panelItem"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.panelItem')}
                type="select"
              >
                <option value="" key="0" />
                {userPanelItems
                  ? userPanelItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-regimen-investigation-obs-labTestItemResult"
                name="labTestItemResult"
                data-cy="labTestItemResult"
                label={translate('tinyMedicRestApp.treatmentRegimenInvestigationObs.labTestItemResult')}
                type="select"
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/treatment-regimen-investigation-obs"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentRegimenInvestigationObsUpdate;
